// [BD feat] Footer — legal modal (Figma 3029:10629 mobile / 3029:10781 desktop; client 2026-10-08)
// AGB / Impressum / Datenschutz open in a full-screen layer under the fixed header, not in the page. Any
// a[href="#bd-legal-…"] opens its text (footer links, "Datenschutzerklärung" in the signup
// consent); the footer repeated inside the layer switches between the texts. Capture phase +
// stopPropagation, so it runs before bd-header.js's document-level anchor scroll.
// Closes on: the header logo ("back to pre launch page", dev note 3029:10692), "GET IN EARLY" (then the
// header scrolls to the form as usual), Esc, and the browser back button. A #bd-legal-… hash on load opens
// its text. While open the page behind is inert and does not scroll; focus returns to the trigger on close.
(function () {
  'use strict';

  var modal = document.querySelector('[data-bd-legal]');
  if (!modal) return;

  // Out of the page <footer>: the layer makes everything else inert, so it cannot sit inside it
  document.body.appendChild(modal);
  modal.setAttribute('data-bd-legal-ready', '');

  var root = document.documentElement;
  var content = modal.querySelector('[data-bd-legal-content]');
  var panels = Array.prototype.slice.call(modal.querySelectorAll('[data-bd-legal-panel]'));
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var current = null;
  var returnFocus = null;
  var pageY = 0;
  var inerted = [];

  function panelFor(id) {
    for (var i = 0; i < panels.length; i++) if (panels[i].id === id) return panels[i];
    return null;
  }

  function syncLinks(id) {
    document.querySelectorAll('[data-bd-legal-link]').forEach(function (link) {
      link.setAttribute('aria-expanded', String(!!id && link.getAttribute('aria-controls') === id));
    });
  }

  function show(panel) {
    panels.forEach(function (p) { p.hidden = p !== panel; });
    modal.setAttribute('aria-labelledby', panel.id + '-title');
    syncLinks(panel.id);
  }

  function focusTitle(panel) {
    var title = panel.querySelector('.bd-legal__title');
    if (title) title.focus({ preventScroll: true });
  }

  // Run cb once el's own transition ends (or straight away without motion)
  function afterTransition(el, ms, cb) {
    if (reduced) return cb();
    var done = false;
    var finish = function (e) {
      if (done || (e && e.target !== el)) return;
      done = true;
      el.removeEventListener('transitionend', finish);
      cb();
    };
    el.addEventListener('transitionend', finish);
    window.setTimeout(finish, ms + 100);
  }

  function setHash(id, push) {
    if (!history.pushState) return;
    var url = location.pathname + location.search + (id ? '#' + id : '');
    if (push) history.pushState({ bdLegal: id }, '', url);
    else history.replaceState(id ? { bdLegal: id } : null, '', url);
  }

  function open(panel) {
    if (current === panel) return;

    // Already open: crossfade to the other text and start it at the top
    if (current) {
      current = panel;
      modal.classList.add('is-switching');
      afterTransition(content, 200, function () {
        if (current !== panel) return;
        show(panel);
        modal.scrollTop = 0;
        modal.classList.remove('is-switching');
        focusTitle(panel);
      });
      return;
    }

    current = panel;
    returnFocus = document.activeElement;
    pageY = window.scrollY;
    show(panel);
    modal.hidden = false;
    modal.classList.remove('is-closing');
    modal.scrollTop = 0;
    root.classList.add('bd-legal-open');
    // Everything but the layer and the header (its pills stay usable on top) goes inert
    inerted = Array.prototype.filter.call(document.body.children, function (el) {
      return el !== modal && !el.querySelector('.bd-header') && !el.inert && el.tagName !== 'SCRIPT';
    });
    inerted.forEach(function (el) { el.inert = true; });
    // Two frames: the layer has to render once in its start state before the transition can run
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () { modal.classList.add('is-open'); });
    });
    focusTitle(panel);
  }

  function close() {
    if (!current) return;
    current = null;
    syncLinks(null);
    root.classList.remove('bd-legal-open');
    if (window.scrollY !== pageY) window.scrollTo({ top: pageY, behavior: 'instant' });
    modal.classList.remove('is-open', 'is-switching');
    modal.classList.add('is-closing');
    inerted.forEach(function (el) { el.inert = false; });
    inerted = [];
    afterTransition(modal, 300, function () {
      if (current) return; // reopened meanwhile
      modal.hidden = true;
      modal.classList.remove('is-closing');
    });
    if (returnFocus && returnFocus.focus && document.contains(returnFocus) && !modal.contains(returnFocus)) {
      returnFocus.focus({ preventScroll: true });
    }
    returnFocus = null;
  }

  document.addEventListener('click', function (e) {
    var target = e.target && e.target.closest ? e.target : null;
    if (!target) return;

    var link = target.closest('a[href^="#bd-legal-"]');
    if (link) {
      var panel = panelFor(link.getAttribute('href').slice(1));
      if (!panel) return;
      e.preventDefault();
      e.stopPropagation();
      var wasOpen = !!current;
      open(panel);
      setHash(panel.id, !wasOpen);
      return;
    }

    // Header pills while the layer is open: the logo leads back to the page, "GET IN EARLY" closes the
    // layer and lets bd-header.js scroll on to the form
    if (current) {
      var pill = target.closest('.bd-header a');
      if (!pill) return;
      var anchor = (pill.getAttribute('href') || '').charAt(0) === '#';
      if (!anchor) { e.preventDefault(); e.stopPropagation(); }
      close();
      setHash(null, false);
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && current) {
      close();
      setHash(null, false);
    }
  });

  // Back / forward
  window.addEventListener('popstate', function () {
    var panel = location.hash ? panelFor(location.hash.slice(1)) : null;
    if (panel) open(panel);
    else close();
  });

  var initial = location.hash ? panelFor(location.hash.slice(1)) : null;
  if (initial) open(initial);
})();
// [/BD feat]
